export default __webpack_public_path__ + "static/image-173abee2cd9761017c47b8d34a75b0ed.png";